import {Component, Input, OnInit} from '@angular/core';
import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';

@Component({
  selector: 'app-basic-area-chart',
  templateUrl: './basic-area-chart.component.html',
  styleUrls: ['./basic-area-chart.component.scss']
})
export class BasicAreaChartComponent implements OnInit {

  @Input() series: any[];
  @Input() xlabel: string;
  @Input() ylabel: string;

  @Input() percent: boolean;
  @Input() width: string = '100%';
  @Input() height: string = '300px';

  @Input() data = [];

  chartOptions: {};
  Highcharts = Highcharts;

  constructor() { }

  ngOnInit(): void {
    this.percent = this.percent!=undefined;

    let thisComponent = this;
    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    let months_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

    this.chartOptions = {
      chart: {
        type: 'area',
        zoomType: 'xy',
        backgroundColor: 'rgba(255,255,255,0)',
        resetZoomButton: {
          position: {
            align: 'left',
            verticalAlign: 'top'
          }
        }
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      navigation: {
        buttonOptions: {
          verticalAlign: 'bottom',
        }
      },
      xAxis: {
        title: {
          text: this.xlabel
        },
        lineWidth: 0,
        minorGridLineWidth: 0,
        lineColor: 'transparent',
        labels: {
          enabled: true
        },
        minorTickLength: 0,
        tickLength: 0
      },
      yAxis: {
        title: {
          text: this.ylabel
        },
        min: 0,
        gridLineDashStyle: "Dash",
        gridLineColor: 'rgba(100,100,100,1)',
        labels: {
          formatter: function () {
            return ((thisComponent.percent?100:1)*this.value).toFixed(1) + (thisComponent.percent?' %':'');
          },
          style: {
            color: 'grey'
          }
        }
      },
      tooltip: {
        formatter: function () {
          const date = new Date();
          date.setTime(this.point.x);
          return '<b>' + this.series.name + '</b><br>' +
            months[date.getMonth()]+' '+date.getDate()+', '+date.getFullYear()+ ': ' +
            ((thisComponent.percent?100:1)*this.y).toFixed(2) + (thisComponent.percent?' %':'');
        },
        useHTML: true
      },
      plotOptions: {
        area: {
          marker: {
            enabled: false
          },
          lineWidth: 0.5
        }
      },
      series: this.data
    };

    HC_exporting(Highcharts);

    setTimeout(() => {
      window.dispatchEvent(
        new Event('resize')
      );
    }, 300);
  }

}
